// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ms-z","tooltipWrapper":"ns-z","icon":"os-z","tooltip":"ps-z","content":"qs-z"};